module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuOTAwOSA1LjU0MjQ1QzYuNTg2NDQgNS42MjEwNyA0Ljk0MzM2IDUuMzMwMTkgMC44ODY3NTEgMy41Mzc3NEwwLjA2MTI3OTMgMy43NzM1OUwzLjU5OTAyIDE1LjA5NDNIMTkuNDAwOUwyMi44MjA3IDMuNTM3NzRMMTcuMDQyNCA1Ljg5NjIzTDExLjM4MiAwTDYuOTAwOSA1LjU0MjQ1WiIgZmlsbD0iIzY4Njg2OCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/crown-grey.svg
// module id = oc8n
// module chunks = 31